import { Button, InputText } from "@sellar-io/components";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DeliveryInstructionsType } from "./useUpdateDeliveryInstructions";
import { InputContainer } from "@sellar-io/components";
import { Dialog, DialogNavigation, DialogContent } from "../modal/Dialog";
import { SpinnerLegacy } from "..";
import { DeliveryInstructionAlert } from "../deliveryInstructionAlert/DeliveryInstructionAlert";

export const EditDeliveryInstructionsDialog = ({
  active,
  onDismiss,
  initialDeliveryInstructions,
  title = "Update delivery instructions",
  description = "This will be displayed to suppliers on all of your new orders, including this one.",
  onSubmit,
  loading,
}: {
  active: boolean;
  onDismiss: () => void;
  initialDeliveryInstructions: string;
  title?: string;
  description?: string;
  onSubmit: (data: DeliveryInstructionsType) => void;
  loading?: boolean;
}) => {
  const { register, handleSubmit, reset } = useForm<DeliveryInstructionsType>({
    defaultValues: {
      deliveryInstructions: initialDeliveryInstructions,
    },
    shouldUseNativeValidation: true,
  });

  useEffect(() => {
    if (initialDeliveryInstructions) {
      reset({ deliveryInstructions: initialDeliveryInstructions });
    }
  }, [reset, initialDeliveryInstructions]);

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={title}
        description={description}
      />
      <DialogContent>
        {loading ? (
          <SpinnerLegacy />
        ) : (
          <form
            className={"flex flex-col gap-2"}
            onSubmit={(e) => e.preventDefault()}
          >
            <InputContainer>
              <InputText
                {...register("deliveryInstructions", { required: true })}
                placeholder={
                  "e.g. Gate code 1234. Leave round the back if no one is in"
                }
              />
            </InputContainer>

            <DeliveryInstructionAlert />

            <Button onClick={handleSubmit(onSubmit)} className={"mt-4 w-full"}>
              Update
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
